import dimensions from '../../../Helpers/dimensions'

const carouselConfig = {
  DRAG_OFFSET_THRESHOLD: dimensions.vw(30),
  DRAG_VELOCITY_THRESHOLD: dimensions.vw(125),
}

export default carouselConfig
